import React, { useEffect } from 'react'
import { Link } from 'gatsby'
import * as styles from './fullWidthCta.module.scss'
import { GatsbyImage } from "gatsby-plugin-image"
import AOS from 'aos';
import 'aos/dist/aos.css';
import TitleSplitter from "../titleSplitter/titleSplitter"

const FullWidthCta = ({ data }) => {

    useEffect(() => {
        AOS.init();
    }, [])

    return(
        <div 
            data-aos={`fade-up`} 
            data-aos-delay={100} 
            className={styles.fullWidthCta}
            aria-hidden="true"
        >
            <div className='container'>
                <div className={styles.card}>

                    <div className={styles.card__text}>
                        <h2>
                            <TitleSplitter title={data.title} />
                        </h2>
                        
                        <p 
                            data-aos={`fade-in`} 
                            data-aos-delay={200}
                        >
                            {data.text}
                        </p>
                        
                        <Link 
                            data-aos={`fade-in`} 
                            data-aos-delay={200} 
                            to={data.linkUrl}
                        >
                            {data.linkText}
                        </Link>
                    </div>

                    <div className={styles.card__image}>
                        <GatsbyImage 
                            image={data.backgroundImage} 
                            alt={data.title}
                            objectFit="cover"
                            loading='lazy'
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FullWidthCta